"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveEntity = exports.publishEvents = exports.getConfigJson = exports.patch = exports.post = exports.get = exports.baseRequestHeaders = exports.SAVE_ENTITY_PATH = exports.EVENTS_PATH = exports.CONFIG_PATH = exports.EVENT_URL = exports.CLIENT_SDK_URL = exports.HOST = void 0;
var utils_1 = require("./utils");
var axios_1 = __importDefault(require("axios"));
var axios_retry_1 = __importDefault(require("axios-retry"));
var axiosClient = axios_1.default.create({
    timeout: 5 * 1000,
    validateStatus: function (status) { return status < 400 && status >= 200; },
});
(0, axios_retry_1.default)(axiosClient, {
    retries: 5,
    // will do exponential retry until axios.timeout
    retryDelay: axios_retry_1.default.exponentialDelay,
    shouldResetTimeout: true,
    retryCondition: function (error) {
        return !error.response || (error.response.status || 0) >= 500;
    },
});
exports.HOST = '.devcycle.com';
exports.CLIENT_SDK_URL = 'https://sdk-api' + exports.HOST;
exports.EVENT_URL = 'https://events' + exports.HOST;
exports.CONFIG_PATH = '/v1/sdkConfig';
exports.EVENTS_PATH = '/v1/events';
exports.SAVE_ENTITY_PATH = '/v1/edgedb';
var baseRequestHeaders = function (sdkKey) {
    return __assign({ 'Content-Type': 'application/json' }, (sdkKey ? { Authorization: sdkKey } : {}));
};
exports.baseRequestHeaders = baseRequestHeaders;
/**
 * Base Requests
 */
var get = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosClient.request({
                    method: 'GET',
                    url: "".concat(url),
                    headers: (0, exports.baseRequestHeaders)(),
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.get = get;
var post = function (url, sdkKey, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosClient.request({
                    method: 'POST',
                    url: url,
                    data: body,
                    headers: (0, exports.baseRequestHeaders)(sdkKey),
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.post = post;
var patch = function (url, sdkKey, body) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosClient.request({
                    method: 'PATCH',
                    url: url,
                    data: body,
                    headers: (0, exports.baseRequestHeaders)(sdkKey),
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.patch = patch;
/**
 * Endpoints
 */
var getConfigJson = function (sdkKey, user, logger, options, extraParams) { return __awaiter(void 0, void 0, void 0, function () {
    var queryParams, url, res, ex_1, errorString;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                queryParams = new URLSearchParams({ sdkKey: sdkKey });
                (0, utils_1.serializeUserSearchParams)(user, queryParams);
                if (options === null || options === void 0 ? void 0 : options.enableEdgeDB) {
                    queryParams.append('enableEdgeDB', options.enableEdgeDB.toString());
                }
                if (extraParams === null || extraParams === void 0 ? void 0 : extraParams.sse) {
                    queryParams.append('sse', '1');
                    if (extraParams.lastModified) {
                        queryParams.append('sseLastModified', extraParams.lastModified.toString());
                    }
                    if (extraParams.etag) {
                        queryParams.append('sseEtag', extraParams.etag);
                    }
                }
                url = "".concat((options === null || options === void 0 ? void 0 : options.apiProxyURL) || exports.CLIENT_SDK_URL).concat(exports.CONFIG_PATH, "?") +
                    queryParams.toString();
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, exports.get)(url)];
            case 2:
                res = _d.sent();
                return [2 /*return*/, res.data];
            case 3:
                ex_1 = _d.sent();
                errorString = JSON.stringify((_c = (_b = (_a = ex_1 === null || ex_1 === void 0 ? void 0 : ex_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.errors);
                logger.error("Request to get config failed for url: ".concat(url, ", ") +
                    "response message: ".concat(ex_1.message) +
                    (errorString ? ", response data: ".concat(errorString) : ''));
                throw new Error("Failed to download DevCycle config." +
                    (errorString ? " Error details: ".concat(errorString) : ''));
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getConfigJson = getConfigJson;
var publishEvents = function (sdkKey, config, user, events, logger, options) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!sdkKey) {
                    throw new Error('Missing sdkKey to publish events to Events API');
                }
                payload = (0, utils_1.generateEventPayload)(config, user, events);
                logger.info("Submit Events Payload: ".concat(JSON.stringify(payload)));
                return [4 /*yield*/, (0, exports.post)("".concat((options === null || options === void 0 ? void 0 : options.apiProxyURL) || exports.EVENT_URL).concat(exports.EVENTS_PATH), sdkKey, payload)];
            case 1:
                res = _a.sent();
                if (res.status >= 400) {
                    logger.error("Error posting events, status: ".concat(res.status, ", body: ").concat(res.data));
                }
                else {
                    logger.info("Posted Events, status: ".concat(res.status, ", body: ").concat(res.data));
                }
                return [2 /*return*/, res];
        }
    });
}); };
exports.publishEvents = publishEvents;
var saveEntity = function (user, sdkKey, logger, options) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!sdkKey) {
                    throw new Error('Missing sdkKey to save to Edge DB!');
                }
                if (!user || !user.user_id) {
                    throw new Error('Missing user to save to Edge DB!');
                }
                if (user.isAnonymous) {
                    throw new Error('Cannot save user data for an anonymous user!');
                }
                return [4 /*yield*/, (0, exports.patch)("".concat((options === null || options === void 0 ? void 0 : options.apiProxyURL) || exports.CLIENT_SDK_URL).concat(exports.SAVE_ENTITY_PATH, "/").concat(encodeURIComponent(user.user_id)), sdkKey, user)];
            case 1:
                res = _a.sent();
                if (res.status === 403) {
                    logger.warn('Warning: EdgeDB feature is not enabled for this project');
                }
                else if (res.status >= 400) {
                    logger.warn("Error saving user entity, status: ".concat(res.status, ", body: ").concat(res.data));
                }
                else {
                    logger.info("Saved user entity, status: ".concat(res.status, ", body: ").concat(res.data));
                }
                return [2 /*return*/, res];
        }
    });
}); };
exports.saveEntity = saveEntity;
exports.default = {
    get: exports.get,
    post: exports.post,
    getConfigJson: exports.getConfigJson,
    publishEvents: exports.publishEvents,
};
//# sourceMappingURL=Request.js.map